/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type LinkPushedBargeCallsToPushingTugMutationVariables = Types.Exact<{
  linkInputs: Array<Types.CallToMasterCallInput>;
}>;


export type LinkPushedBargeCallsToPushingTugMutation = {
  __typename?: 'Mutation',
  linkCallsToMasterCalls?: string | null
};


export const LinkPushedBargeCallsToPushingTugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkPushedBargeCallsToPushingTug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallToMasterCallInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkCallsToMasterCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"linkInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkInputs"}}}]}]}}]} as unknown as DocumentNode<LinkPushedBargeCallsToPushingTugMutation, LinkPushedBargeCallsToPushingTugMutationVariables>;